import { render, staticRenderFns } from "./yellowMark.vue?vue&type=template&id=50a8483b&scoped=true&"
import script from "./yellowMark.vue?vue&type=script&lang=js&"
export * from "./yellowMark.vue?vue&type=script&lang=js&"
import style0 from "./yellowMark.vue?vue&type=style&index=0&id=50a8483b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a8483b",
  null
  
)

export default component.exports